export default "__VITE_ASSET__992a65e4__"